module.exports = __webpack_public_path__ + "img/salsa_1805.a5fd9793.jpg";